import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useToken } from '@ori/auth';
import { useGraphqlQuery } from '@ori/fetching';
import { print } from 'graphql';
import cloneDeep from 'lodash.clonedeep';
import { useMemo } from 'react';
import { useCookieStoreInfo } from "./useCookieStoreInfo";
import { useConfiguration } from "../ConfigurationProvider";
import useSponsorPersonalBeautyStoreInfo from "../../hooks/useSponsorPersonalBeautyStoreInfo";
import { ReferralType } from "../../models";
import { beautyStoreQuery } from "../../queries/client";
var query = print(beautyStoreQuery);
export var usePersonalBeautyStoreData = function usePersonalBeautyStoreData() {
  var _useConfiguration = useConfiguration(),
    isEnabled = _useConfiguration.isEnabled,
    currentLanguage = _useConfiguration.currentLanguage,
    graphqlUrl = _useConfiguration.graphqlUrl,
    tenant = _useConfiguration.tenant;
  var _useToken = useToken(),
    isAnonymousUser = _useToken.isAnonymousUser,
    customerId = _useToken.customerId,
    token = _useToken.token;
  var _useCookieStoreInfo = useCookieStoreInfo(),
    type = _useCookieStoreInfo.type,
    owner = _useCookieStoreInfo.owner,
    productListType = _useCookieStoreInfo.productListType;
  var _useSponsorPersonalBe = useSponsorPersonalBeautyStoreInfo(),
    sponsorData = _useSponsorPersonalBe.data;
  var shouldCall = type === ReferralType.PBS && isEnabled && Boolean(owner);
  var _useGraphqlQuery = useGraphqlQuery({
      url: graphqlUrl,
      query: query,
      tenant: tenant,
      language: currentLanguage,
      customerId: customerId,
      token: token,
      variables: {
        name: isAnonymousUser ? owner : sponsorData === null || sponsorData === void 0 ? void 0 : sponsorData.name,
        productListType: productListType
      },
      skip: isAnonymousUser ? !shouldCall : !(sponsorData !== null && sponsorData !== void 0 && sponsorData.name)
    }),
    dataFromApi = _useGraphqlQuery.data,
    error = _useGraphqlQuery.error;
  if (error) {
    console.error(error);
  }
  return useMemo(function () {
    if (!(dataFromApi !== null && dataFromApi !== void 0 && dataFromApi.beautyStore) || !dataFromApi.application) {
      return null;
    }
    var result = cloneDeep(dataFromApi);
    if (process.env.NODE_ENV !== 'production') {
      var _result$beautyStore, _result$beautyStore$p;
      if ((_result$beautyStore = result.beautyStore) !== null && _result$beautyStore !== void 0 && (_result$beautyStore$p = _result$beautyStore.profile) !== null && _result$beautyStore$p !== void 0 && _result$beautyStore$p.photoUrl) {
        var photoUrl = new URL(result.beautyStore.profile.photoUrl);

        // photoUrl is readOnly so it cannot be reassigned
        return _objectSpread(_objectSpread({}, result), {}, {
          beautyStore: _objectSpread(_objectSpread({}, result.beautyStore), {}, {
            profile: _objectSpread(_objectSpread({}, result.beautyStore.profile), {}, {
              photoUrl: "".concat(photoUrl.pathname, "?").concat(photoUrl.searchParams.toString())
            })
          })
        });
      }
      return result;
    }
    return result;
  }, [dataFromApi]);
};